<!--开发者规范-->
<template>
    <div style="padding:10px 10px 10px 10px">
      <h1 style="text-align: center">开发者个人信息和数据保护承诺函</h1>
      <p>为实现双方之【广告投放】合作，我司会向贵司（“北京爱爱奇艺科技有限公司及其关联公司”）提供相关个人信息，为更好的保护个人信息，确保信息处理的合法合规性，我司现向贵司做出如下承诺。本承诺函自我方勾选同意之日起生效，且不因贵我双方签署的协议和本次合作的无效、中止、终止、解除而终止或丧失效力：</p>
      <br>
      <p>我司在此承诺并保证：</p>
      <p>1.有能力履行其于本承诺函下之义务，并且该履行义务的行为不违反对其有约束力的任何适用法律、法规、规章或其他规范性文件（包括国家、行业标准，下同）（以下简称“法律法规”），亦不会侵犯任何第三方之合法权益。</p>
      <p>2.严格遵守所有适用的法律法规，按照“合法正当、目的明确、公开透明”等原则处理个人信息，处理行为不违反任何适用的法律法规及本承诺函的约定，且不违背公序良俗。</p>
      <p>3.遵守贵司以书面形式向我司提供的个人信息和数据保护政策、声明或通知；如贵司要求，我方承诺签订任何进一步有关个人信息和数据的保护协议，包括任何适用的数据安全保护协议，或采取贵司要求的任何其他步骤，以满足合规要求。</p>
      <p>4.我司仅基于本承诺函之目的收集、使用、提供或以其他形式处理个人信息，不超出本承诺函约定范围处理个人信息，且不利用个人信息以任何形式获取超出合作范围的利益。</p>
      <p>5.我司基于本承诺函收集的个人信息，为实现本承诺函之目的最小必要范围，不收集任何与此承诺函之目的无关的非必要信息。</p>
      <p>6.如涉及SDK接入的，我司知悉并认可爱奇艺联盟平台SDK具备收集个人信息的功能，并认可该等信息的收集均为双方合作之必要目的所需。</p>
      <p>7.已认真阅读并理解爱奇艺联盟媒体服务平台的
      <a href="https://union.iqiyi.com/platform/developerAgreement">用户协议</a>、
      <a href="https://union.iqiyi.com/platform/privacyPolicy">隐私政策</a>
      以及
      <a href="https://union.iqiyi.com/platform/developerGuide">开发者合规指引</a>
      等文档，并在遵守相关文档的前提下，进行本次合作。</p>
      <p>8.在双方订立合作协议前，贵司有权对我司进行数据合规尽职调查的风险评估，并审查我司所提供的关于所共享的个人信息的合法来源证明及相关文件，以及官网公开的用户协议与隐私政策，如贵司发现我司存在不合规的情形，则贵司有权要求我司修订用户协议与隐私政策的内容或完善相应的授权机制及其他合规机制。我司在爱奇艺联盟媒体服务平台用户协议、隐私政策、开发者合规指引下的全部义务、责任不因本条款下的贵司的风险评估权利而构成任何形式的豁免，我司仍应根据上述内容履行相应义务并承担法律责任。</p>
      <p>9.我司针对本承诺函之目的收集、使用、提供或者以其他形式处理个人信息的行为，已经获得个人信息主体及其他相关授权方的有效同意，符合与前述主体约定之目的。</p>
      <p>10.向贵司提供的信息来源合法合规，已经获得个人信息主体及其他相关授权方的有效同意，不存在任何以窃取或其他非法方式获取信息的行为。</p>
      <p>11.向贵司提供的相关个人信息，均未超出我方获取前述信息、或基于前述信息提供相关服务所需的必要存储期限，因本承诺函之目的而需对前述信息进行的处理亦未超出上述期限。同时，在相关处理完成后，我司将在处理目的实现后的5个工作日内以不可恢复方式销毁或删除、匿名化处理个人信息及其所有形式的数据备份。</p>
      <p>12.保证个人信息全部存储在中华人民共和国大陆地区，不得向大陆地区外传输，亦不得允许任何境外处理行为（包括境外访问），个人信息的所有处理均在中华人民共和国大陆地区进行。</p>
      <p>13.建立严格的保密制度、采取严格的保密措施（应不低于我司为保护我司掌握的个人信息所采用的制度和措施，亦不低于合理程度）来保护本承诺函所涉个人信息，确保个人信息不受到任何篡改、损坏、丢失等。</p>
      <p>14.严格按照法律法规规定，积极响应个人信息主体的请求，并在收到相应请求后的15个工作日内完成处理。</p>
      <br>

      <p>若我司违背上述承诺：</p>
      <p>1.无论故意或过失，应当立即停止侵害，并在第一时间采取一切必要措施防止相关用户个人信息和数据的扩散或受到进一步侵害，尽最大可能消除不利影响。</p>
      <p>2.贵司有权暂停或终止与我司的合作，并有权追究我司的违约责任，对贵司造成任何不利影响的，我司应当负责消除（如赔礼道歉、公开申明等形式，具体以贵司要求为准）。且若对用户、贵司造成任何损失的，我司应赔偿前述主体所遭受的全部损失。</p>
      <p>3.对因我司违反本承诺函而引起任何针对贵司的权利主张、诉讼、仲裁等，我司应负责应诉，并为贵司进行抗辩，或在贵司的要求下合作抗辩，以保证贵司的利益不受损害。</p>
    </div>
</template>

<script>
export default {
    name: "DeveloperNorms"
}
</script>

<style scoped>

</style>